/* eslint-disable prettier/prettier */
import React from 'react';
import MainLayout from '../Layouts/Mainlayout';
import UnsubscribeList from './UnsubscribeList';

export default function Users(): JSX.Element {
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <UnsubscribeList />
      </MainLayout>
    </div>
  );
}
